/**
 * RedirectByGurudwaraId — 301-style redirect from /gurudwara/by-id/:id to /gurudwara/:slug
 *
 * Fetches the gurudwara by UUID, then Navigate(replace) to the canonical
 * /gurudwara/:slug URL.
 */

import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import PageSkeleton from './ui/PageSkeleton';

export default function RedirectByGurudwaraId() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const { data, isLoading, isError } = useQuery({
    queryKey: ['gurudwara-by-id-redirect', id],
    queryFn: async () => {
      const res = await api.get(`/gurudwaras/by-id/${id}`);
      return res.data as { slug?: string; id: string };
    },
    enabled: !!id,
    retry: false,
    staleTime: Infinity,
  });

  useEffect(() => {
    if (!isLoading) {
      if (data?.slug) {
        navigate(`/gurudwara/${data.slug}`, { replace: true });
      } else if (isError) {
        navigate('/gurudwaras', { replace: true });
      }
    }
  }, [data, isLoading, isError, navigate]);

  return <PageSkeleton />;
}
